import { ActivityEventNames } from 'generated/graphql';

/**
 * ActivtyEventNames as they stored in the backend database.
 */
export const ACTIVITY_EVENT_NAMES = ActivityEventNames;

export const ALL_MASS_OP_EVENTS = [
  ACTIVITY_EVENT_NAMES.MassAddFollowUp,
  ACTIVITY_EVENT_NAMES.MassCompleteFollowUp,
  ACTIVITY_EVENT_NAMES.MassRemoveTags,
  ACTIVITY_EVENT_NAMES.MassAddAssessment,
  ACTIVITY_EVENT_NAMES.MassAddOrUpdateEntityConnection,
  ACTIVITY_EVENT_NAMES.MassApplyTags,
  ACTIVITY_EVENT_NAMES.MassRemoveEntityConnection,
  ACTIVITY_EVENT_NAMES.MassAddEntitiesToCampaign,
  ACTIVITY_EVENT_NAMES.MassAddEntitiesToAction
];

export const ALL_HOME_EMAIL_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateEmailHome,
  ACTIVITY_EVENT_NAMES.UpdateEmailHome,
  ACTIVITY_EVENT_NAMES.UpdateEmailHomeBad,
  ACTIVITY_EVENT_NAMES.UpdateEmailHomeDoNotContact,
  ACTIVITY_EVENT_NAMES.UpdateEmailHomeVerified,
  ACTIVITY_EVENT_NAMES.SubscribeEmailHome,
  ACTIVITY_EVENT_NAMES.UnsubscribeEmailHome
];

export const ALL_WORK_EMAIL_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateEmailWork,
  ACTIVITY_EVENT_NAMES.UpdateEmailWork,
  ACTIVITY_EVENT_NAMES.UpdateEmailWorkBad,
  ACTIVITY_EVENT_NAMES.UpdateEmailWorkDoNotContact,
  ACTIVITY_EVENT_NAMES.UpdateEmailWorkVerified,
  ACTIVITY_EVENT_NAMES.SubscribeEmailWork,
  ACTIVITY_EVENT_NAMES.UnsubscribeEmailWork
];

export const ALL_CELL_PHONE_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreatePhoneNumberCell,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberCell,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberCellBad,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberCellVerified,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberCellDoNotContact,
  ACTIVITY_EVENT_NAMES.SubscribePhoneNumberCell,
  ACTIVITY_EVENT_NAMES.UnsubscribePhoneNumberCell
];

export const ALL_WORK_PHONE_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreatePhoneNumberWork,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberWork,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberWorkBad,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberWorkVerified,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberWorkDoNotContact,
  ACTIVITY_EVENT_NAMES.SubscribePhoneNumberWork,
  ACTIVITY_EVENT_NAMES.UnsubscribePhoneNumberWork
];

export const ALL_HOME_PHONE_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreatePhoneNumberHome,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberHome,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberHomeBad,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberHomeDoNotContact,
  ACTIVITY_EVENT_NAMES.UpdatePhoneNumberHomeVerified,
  ACTIVITY_EVENT_NAMES.UnsubscribePhoneNumberHome,
  ACTIVITY_EVENT_NAMES.SubscribePhoneNumberHome
];

export const ALL_SOCIAL_PROFILE_FACEBOOK_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileFacebook,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileFacebook,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileFacebookVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileFacebookBad,
];

export const ALL_SOCIAL_PROFILE_WHATSAPP_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileWhatsapp,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWhatsapp,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWhatsappVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWhatsappBad,
];

export const ALL_SOCIAL_PROFILE_INSTAGRAM_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileInstagram,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileInstagram,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileInstagramVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileInstagramBad,
];

export const ALL_SOCIAL_PROFILE_TIKTOK_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileTiktok,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTiktok,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTiktokVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTiktokBad,
];

export const ALL_SOCIAL_PROFILE_TWITTER_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileTwitter,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTwitter,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTwitterVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileTwitterBad,
];

export const ALL_SOCIAL_PROFILE_LINKEDIN_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileLinkedin,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileLinkedin,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileLinkedinVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileLinkedinBad,
];

export const ALL_SOCIAL_PROFILE_DISCORD_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileDiscord,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileDiscord,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileDiscordVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileDiscordBad,
];

export const ALL_SOCIAL_PROFILE_WECHAT_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileWechat,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWechat,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWechatVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWechatBad,
];

export const ALL_SOCIAL_PROFILE_WEBSITE_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileWebsite,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWebsite,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWebsiteVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileWebsiteBad,
];

export const ALL_SOCIAL_PROFILE_OTHER_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateSocialProfileOther,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileOther,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileOtherVerified,
  ACTIVITY_EVENT_NAMES.UpdateSocialProfileOtherBad
];

export const ALL_CALENDAR_RESPONSE_EVENTS = [
  ACTIVITY_EVENT_NAMES.CreateCalendarEventResponseTags,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusAttended,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusConfirmed,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusDeclined,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusDoubleConfirmed,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusNoShow,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusRsvp,
  ACTIVITY_EVENT_NAMES.UpdateCalendarEventResponseStatusTentative,
];

export const ALL_SOCIAL_EVENTS = [
  ...ALL_SOCIAL_PROFILE_FACEBOOK_EVENTS,
  ...ALL_SOCIAL_PROFILE_DISCORD_EVENTS,
  ...ALL_SOCIAL_PROFILE_INSTAGRAM_EVENTS,
  ...ALL_SOCIAL_PROFILE_LINKEDIN_EVENTS,
  ...ALL_SOCIAL_PROFILE_OTHER_EVENTS,
  ...ALL_SOCIAL_PROFILE_TIKTOK_EVENTS,
  ...ALL_SOCIAL_PROFILE_TWITTER_EVENTS,
  ...ALL_SOCIAL_PROFILE_WEBSITE_EVENTS,
  ...ALL_SOCIAL_PROFILE_WECHAT_EVENTS,
  ...ALL_SOCIAL_PROFILE_WHATSAPP_EVENTS
];
